import { useTheme } from "@emotion/react";
import { ITheme } from ".";

export default useTheme as () => ITheme;
